import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#263f42',
    },
    secondary: {
      main: '#26a768',
    },
  },
  typography: {
    fontFamily: 'Raleway, sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 800,
  },
  overrides: {
    MuiIconButton: {
      colorPrimary: {
        color: '#fff',
      },
    },
    MuiRadio: {
      colorPrimary: () => ({
        color: '#00963d',
        '&$checked': {
          color: '#00963d',
        },
      }),
    },
    MuiLink: {
      root: {
        fontSize: '20px',
        fontWeight: 600,
      },
    },
  },
});
